import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import styled from 'styled-components';
import QRCode from 'qrcode.react';
import ResultsCanvas from './ResultsCanvas';
import ResultsMaths from './ResultsMaths';
import { listenForScores } from '../db';
import { IAppState } from '../db/reducers';
import { setResultsViewIsBubbles } from '../db/dispatchers';
import config from '../config';
import { device } from '../theme';
import LottieLogo from './LottieLogo';

const SResults = styled.div`
  display: none; 

  @media ${device.mobileL}, (orientation: landscape) {
    display: flex;
    height: 10vh;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 90vw;
    height: 90vh;
    flex-direction: row;
  }
`;

const SResultsAlt = styled.div`
  display: flex;
  height: 190vh;
  @media ${device.mobileL}, (orientation: landscape) {
    display: none;
  }
`

const SResultsHeader = styled.div`
  display: flex;
  height: 80vh;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 5vh;
  width: 20vw;
`;

const SResultsBody = styled.div`
  display: flex;
  height: 80vh;
  width: 70vw;
  margin-top: 5vh;
`;

const SResultsFooter = styled.div`
  display: flex;
  height: 10vh;
  width: 10vw;
`;

const SResultsText = styled.p`
  display: flex;
  justify-content: flex-start;
  margin: 0 0 0 0;
  text-align: left;
  
  @media ${device.tablet}, (orientation: landscape)  {
    width: 90vw;
    max-width: 90vw;
    flex-wrap: wrap;
  }
`;


const SSpan = styled.span`
  display: none;
  @media ${device.laptop} and (orientation: landscape) {
    display: flex;
    position: absolute;
    left: 4vw;
    bottom: 4vh;
  }
`;

interface IMatchParams {
  pollId: string;
}

interface IResultsProps extends RouteComponentProps {
  polls: any;
  resultsViewIsBubbles: boolean;
  match: {
    isExact: any;
    path: any;
    url: any;
    params: IMatchParams;
  };
  dispatch: ThunkDispatch<any, any, any>;
}

const Results: React.SFC<IResultsProps> = (props) => {
  const location = useLocation();
  
  const { dispatch, resultsViewIsBubbles, polls } = props
  const { pollId } = props.match.params
  const { baseUrl } = config;  
  
  useEffect(() => {
    dispatch(listenForScores(pollId));
  }, [dispatch, pollId])
  
  function handleClick(event: any) {
    event.preventDefault();
    dispatch(setResultsViewIsBubbles(!resultsViewIsBubbles));
  };

  if (!polls) return (<h3>Loading...</h3>)
  if (!polls[pollId]) return (<h1>Oops, can't find that poll...</h1>)

  return (
    <>
      {!polls && (<h3>Loading...</h3>)}
      {!polls && !polls[pollId] && (<h1>Oops, can't find that poll...</h1>)}
      <>
        <SResultsAlt>
          <LottieLogo height={'10vw'} width={'10vw'} />
          <p>Turn landcape to view results.</p> 
        </SResultsAlt>

        <SResults className='SResults'>
          <SResultsHeader className='SResultsHeader'>    
            {           
              !location.pathname.match('/admin') &&
                <div style={{ alignItems: 'flex-start', justifyContent: 'flex-start', marginBottom: '1em' }}>
                  <LottieLogo height={'8vh'} width={'8vh'}/>          
                </div>
            }

            <SResultsText>
              Poll: {pollId}
            </SResultsText>

            <ResultsMaths scores={polls[pollId].scores} />

            <button style={{ margin: '0 0 1vh 0' }} onClick={handleClick}>Change View</button>
            <a
              style={{ alignItems: 'flex-start' }}
              href={config.formscoreUrl}
            >
              <button style={{ margin: '0 0 1vh 0' }}>Find Out More</button>
            </a>

          </SResultsHeader>

          <SResultsBody className='SResultsBody'>
            <ResultsCanvas />
          </SResultsBody>
          
          <SResultsFooter className='SResultsFooter'>
            <SSpan onClick={handleClick}>
              <QRCode
                value={`${baseUrl}/p/${pollId}`}
                size={1600}
                style={{
                  maxWidth: '20vw',
                  maxHeight: '30vh',
                  height: '20vh',
                  width: '20vh',
                }}
              />
            </SSpan>
          </SResultsFooter>

        </SResults>
      </>
    </>
  );
}

const mapStateToProps = (state: IAppState) => {
  return {
    polls: state.polls,
    resultsViewIsBubbles: state.resultsViewIsBubbles,
  };
};

export default connect(mapStateToProps)(Results);
